
export function setParameter(key, value, url) {

	if (!url) url = window.location.href;
    var baseUrl = url.split('?')[0],
        urlQueryString = '?' + url.split('?')[1],
        newParam = key + '=' + value,
        params = '?' + newParam;                     

    // If the "search" string exists, then build params from it
    if (urlQueryString != '?undefined') {
        var updateRegex = new RegExp('([\?&])' + key + '[^&]*');
        var removeRegex = new RegExp('([\?&])' + key + '=[^&;]+[&;]?');

        if (typeof value === 'undefined' || value === null || value === '' || isEmpty(value)) { // Remove param if value is empty
            params = urlQueryString.replace(removeRegex, "$1");            
            params = params.replace(/[&;]$/, "");            

        } else if (urlQueryString.match(updateRegex) !== null) { // If param exists already, update it
            params = urlQueryString.replace(updateRegex, "$1" + newParam);            

        } else { // Otherwise, add it to end of query string
            params = urlQueryString + '&' + newParam;

        }
    }

    // no parameter was set so we don't need the question mark
    params = params === '?' ? '' : params;

    return baseUrl + params;
}

function isEmpty(obj) {
    for(var key in obj) {
        if(obj.hasOwnProperty(key))
            return false;
    }
    return true;
}   